module.exports = __webpack_public_path__ + "static/media/SM-logo-slim.6189184d.png";